import { render, staticRenderFns } from "./Promote.vue?vue&type=template&id=0a2791c6&scoped=true"
import script from "./Promote.vue?vue&type=script&lang=js"
export * from "./Promote.vue?vue&type=script&lang=js"
import style0 from "./Promote.vue?vue&type=style&index=0&id=0a2791c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2791c6",
  null
  
)

export default component.exports